import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  @Input() title: string;
  @Input() content: string;
  @Input() withConfirmation?: boolean;

  constructor(protected ref: NbDialogRef<DialogComponent>) {}

  dismiss(confirm: boolean) {
    this.ref.close(confirm);
  }
}
